<!-- eslint-disable max-len -->
<template>
  <div>
    <b-modal
      id="workorderLineItemAddModal"
      size="lg"
      @ok="onWorkorderLineItemAddModalOk()"
    >
      <template v-slot:modal-title>Add Work Order {{ workorderNumber }} Line Item</template>
      <b-card-body
        v-if='totalAvailableExceeded'
        class='project-workorder-lineitem-edit-card-warning text-danger'
      >
        <span class='project-workorder-bills-items-details-label'>This line item exceeds amount remaining for the funding source selected.&nbsp;</span>
        <span>Please adjust the amount.</span>
      </b-card-body>
      <b-card-body class='project-workorder-lineitem-edit-card-body'>
        <b-row>
          <b-col>
            <span class='details-label project-workorder-bills-items-details-label'>Budgeted: </span>
            <span class='project-workorder-bills-items-details-label'>
              <!-- ({{ totalBudgeted }}) -->
              {{ totalBudgeted | toCurrency }}
            </span>
          </b-col>
          <b-col>
            <span class='details-label project-workorder-bills-items-details-label'>Obligated: </span>
            <span class='project-workorder-bills-items-details-label'>
              <!-- ({{ totalObligated }}) -->
              {{ totalObligated | toCurrency }}
          </span>
          </b-col>
          <b-col>
            <span class='details-label project-workorder-bills-items-details-label'>Available: </span>
            <span v-bind:class="{'project-workorder-bills-items-details-label': true, 'text-danger': totalAvailable < 0}">
              <!-- ({{ totalAvailable }}) -->
              {{ totalAvailable | toCurrency }}
            </span>
          </b-col>
        </b-row>
      </b-card-body>
      <VueFormGenerator
        :model="workorderLineItemAddModel"
        :schema="workorderLineItemAddSchema"
        :options="{
          validateAfterLoad: false,
          validateAfterChanged: true,
          validateAsync: true
        }"
        @model-updated='onWorkorderLineItemAddModelUpdated'
        @validated="onWorkorderLineItemAddModelValidated"
      />
      <div>
        <b-card-body>
        </b-card-body>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>Cancel</b-button>
        <b-button size="sm" variant="success" @click="ok" class='btn-success' :disabled='!workorderLineItemAddModelValid'>Save</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable max-len, no-restricted-properties, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import ProjectSchemaHelper from '@/mixins/projectSchemaHelper';

export default {
  name: 'ProjectWorkorderLineItemAdd',
  mixins: [
    ProjectSchemaHelper,
  ],
  computed: {
    ...mapState('Pricelist', {
      pricelistEntries: (e) => e.pricelistEntries,
    }),
    ...mapState('Project', {
      products: (state) => state.products,
      project: (state) => state.project,
      projectBudget: (state) => state.projectBudget,
    }),
    ...mapState('Workorder', {
      workorderLineItemAddModel: (e) => e.workorderLineItemAddModel,
      workorderLineItemAddedModel: (e) => e.workorderLineItemAddedModel,
    }),
    totalAvailableExceeded() {
      if (!this.workorderLineItemAddModel) return false;

      const totalAvailable = Math.round(this.totalAvailable * 100);

      const itemCost = Math.round(this.workorderLineItemAddModel.quantity * (this.workorderLineItemAddModel.unitCost * 100));

      const districtPartnerCost = itemCost * (this.workorderLineItemAddModel.districtAndPartnerCost * 0.01);

      const totalAvailableExceeded = totalAvailable < districtPartnerCost;

      return totalAvailableExceeded;
    },
  },
  data() {
    return {
      totalBudgeted: 0,
      totalObligated: 0,
      totalAvailable: 0,
      workorderLineItemAddFundingSources: [],
      workorderLineItemAddModelValid: false,
      workorderLineItemAddSchema: null,
      workorderLineItemPricelistEntries: [],
      districtAndPartnerCostValue: null,
    };
  },
  async mounted() {
    this.totalBudgeted = this.workorderLineItemAddModel.totalBudgeted;
    this.totalObligated = this.workorderLineItemAddModel.totalObligated;
    this.totalAvailable = (Math.round(this.totalBudgeted * 100) - Math.round(this.totalObligated * 100)) / Math.pow(10, 2);

    this.workorderNumber = this.workorderLineItemAddModel.workorderNumber;

    this.workorderLineItemAddFundingSources = this.workorderLineItemAddModel.fundingSources;

    this.workorderLineItemPricelistEntries = this.pricelistEntries.map((e) => {
      const workorderLineItemPricelistEntry = {
        id: e.id,
        price: e.price,
      };
      const product = this.products.find((p) => p.producT_ID === e.productId && p.active === true);
      if (product) {
        workorderLineItemPricelistEntry.name = product.producT_NAME;
        workorderLineItemPricelistEntry.unit = product.customfields.find((customfield) => customfield.fielD_NAME === 'Unit__c').fielD_VALUE;
      }
      return workorderLineItemPricelistEntry;
    }).filter((e) => e.name && e.name != null).sort(
      (a, b) => a.name.localeCompare(b.name),
    );

    this.workorderLineItemAddSchema = this.getProjectWorkorderLineItemAddSchema();

    this.$bvModal.show('workorderLineItemAddModal');

  },
  methods: {
    async onWorkorderLineItemAddModalOk() {
      await this.$store.dispatch('Workorder/setFormLoading', true);
      await this.$store.dispatch('Workorder/postWorkorderLineItem', this.workorderLineItemAddModel);
      await this.$store.dispatch('Workorder/setFormLoading', false);
    },
    onWorkorderLineItemAddModelUpdated(fieldValue, fieldName) {
      if (fieldName === 'pricebookEntryId') {
        const pricelistEntry = this.pricelistEntries.find((e) => Number(e.id) === Number(fieldValue));
        this.workorderLineItemAddModel.costItemId = pricelistEntry.productId;
        this.workorderLineItemAddModel.unitCost = pricelistEntry.price;
      }
      this.workorderLineItemAddModel.itemCost = this.$options.filters.toCurrency(
        this.workorderLineItemAddModel.unitCost * this.workorderLineItemAddModel.quantity,
      );

      const distPartnerCost = this.workorderLineItemAddModel.unitCost * this.workorderLineItemAddModel.quantity * this.workorderLineItemAddModel.districtAndPartnerCost * 0.01;
      let distPartnerCostRounded = Math.round(distPartnerCost * 100);

      /* eslint-disable-next-line */
      distPartnerCostRounded /= Math.pow(10, 2);

      this.workorderLineItemAddModel.districtAndPartnerCostValue = distPartnerCostRounded;
    },
    onWorkorderLineItemAddModelValidated(isValid, errors) {
      this.workorderLineItemAddModelValid = isValid;
      this.validateWorkOrderLineItemAddFields(errors);
    },
    validateWorkOrderLineItemAddFields(errors) {
      this.workorderLineItemAddModelValid = true;

      if (!this.workorderLineItemAddModel.pricebookEntryId || this.workorderLineItemAddModel.pricebookEntryId === null) {
        this.workorderLineItemAddModelValid = false;
      }

      if (!this.workorderLineItemAddModel.unitCost || this.workorderLineItemAddModel.unitCost === null) {
        this.workorderLineItemAddModelValid = false;
      }

      if (!this.workorderLineItemAddModel.quantity || this.workorderLineItemAddModel.quantity === null) {
        this.workorderLineItemAddModelValid = false;
      }

      if (this.workorderLineItemAddModel.districtAndPartnerCost === null) {
        this.workorderLineItemAddModelValid = false;
      }

      if (!this.workorderLineItemAddModel.fundingSourceId || this.workorderLineItemAddModel.fundingSourceId === null) {
        this.workorderLineItemAddModelValid = false;
      }

      if (this.totalAvailableExceeded) {
        this.workorderLineItemAddModelValid = false;
      }

      if (errors && errors.length > 0) {
        this.workorderLineItemAddModelValid = false;
      }
    },
  },
};
</script>
